<template>
   <div id="idEditarClientesTerrestresModal">
        <Button
            :size="15"
            color="#FD9137"
            colorText="#ffffff"
            tooltip="Editar proveedores seleccionados"
            icon="far fa-edit"
            round
            :width="30"
            class="mr-2"
            traslate
            @click.native="actionSetShowModalEditClientGroundModal(true)"
            :inactive="ids.length < 1"

        />

        <ui-modal 
            ref="modal" 
            title="Editar Múltiple Clientes Terrestres"
            transition="scale-up"
            size="large"
            @close="actionSetShowModalEditClientGroundModal(false); ActionSetZindexModal(false)"
        >

            <client-terrestre-form
                :ids = "idsData"
                :closeModal="cerrarModal"
            />

        </ui-modal>

    </div>

</template>

<script>

    // UI Modal
    import UiModal from "keen-ui/src/UiModal";
    import Button from '@/components/common/Button.vue';
    import ClientTerrestreForm from './ClientTerrestreForm.vue';
    import { mapState, mapActions } from "vuex";

    export default {
        props: {
            ids  : { type: Array, default: () => [] },
        },
        data(){
             return {
                idsData: []
             }
         },
        components: {
            UiModal,
            Button,
            ClientTerrestreForm
        },
        computed: {
            ...mapState("serviciosLogisticos", [
                "showModalEditClientGroundModal",
             ])
        },
        methods : {

            ...mapActions([ "ActionSetZindexTablaModal","ActionSetZindexModal"]),

            ...mapActions("serviciosLogisticos",[
                "actionSetShowModalEditClientGroundModal",
            ]),
            openModal(ref) {

                this.ActionSetZindexTablaModal(true);
                this.ActionSetZindexModal(true);
                this.$refs[ref].open();
            },
            
            closeModal(ref) {
                this.ActionSetZindexTablaModal(false);
                this.$refs[ref].close();
            },
            cerrarModal(){
                this.closeModal('modal');
            },
        },
        watch: {
            showModalEditClientGroundModal: function( _new ){

                console.log("_new --->" , _new );
                console.log("this.ids --->" , this.ids );
                
                this.idsData = _new ? this.ids : [];

                _new ? this.openModal("modal") : this.cerrarModal() ;
            }
        }

    }

</script>

<style>

#idEditarClientesTerrestresModal .ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
    width: 92% !important;
}
</style>